import { useEffect } from 'react';

export const ORIGIN = 'https://emboscale.com';

// Markdown → plain text for structured data (links keep their text, emphasis dropped).
export const plain = (md) => md
  .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
  .replace(/[*_`>]/g, '')
  .replace(/\s+/g, ' ')
  .trim();

// "## Frequently asked questions" with "### Question" children → FAQ pairs.
export const faqFrom = (md) => {
  const m = md.match(/^##\s+Frequently asked questions\s*$([\s\S]*?)(?=^##\s|(?![\s\S]))/im);
  if (!m) return [];
  return m[1].split(/^###\s+/m).slice(1).map((block) => {
    const [q, ...rest] = block.split('\n');
    const end = rest.findIndex((l) => /^(\*Further reading|---|Related:|\[Book a demo)/.test(l.trim()));
    return { q: plain(q), a: plain((end < 0 ? rest : rest.slice(0, end)).join('\n')) };
  }).filter((f) => f.q && f.a);
};

export const faqPage = (faq) => ({
  '@type': 'FAQPage',
  mainEntity: faq.map((f) => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } })),
});

// Injects one JSON-LD block into <head>; the prerender snapshot keeps it in the HTML.
export const useJsonLd = (data) => {
  useEffect(() => {
    if (!data) return undefined;
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = 'page-jsonld';
    el.textContent = JSON.stringify(data);
    document.head.appendChild(el);
    return () => el.remove();
  }, [data]);
};
